import React from "react";
import PropTypes from 'prop-types';

const Face = props => (
  <svg className={props.className} width={props.width} height={props.height} viewBox="0 0 9 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-631.000000, -465.000000)" fill="#FFFFFF">
            <g transform="translate(450.000000, 170.000000)">
                <g>
                    <g transform="translate(75.000000, 278.000000)">
                        <g transform="translate(106.000000, 9.000000)">
                            <g transform="translate(0.000000, 6.000000)">
                                <path d="M2.00704595,11 L2.00704595,19.9999618 L5.29960308,19.9999618 L5.29956076,20 L5.29956076,11 L9,11 L9,8 L5.29956076,8 L5.29956076,5.06139615 L5.28004912,4.95380049 C5.31382415,5.15649758 5.27568969,5.24372802 5.23628549,5.28166924 C5.24106817,5.27696958 5.85388596,4.76443823 8.60341856,5.06724208 L9,2.11676714 C6.0246657,1.79008286 4.0206385,2.14729589 2.87685868,3.20838938 C2.1010912,3.92671273 1.9289994,4.80627674 2.02351022,5.39159564 L2.00704595,5.17170464 L2.00704595,8 L0,8 L0,11 L2.00704595,11 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
  </svg>
);

Face.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
}

Face.defaultProps = {
  width: 9,
  height: 18,
  className: ""
}

export default Face;



// WEBPACK FOOTER //
// ./src/components/svgs/Face.js